export enum ErrorsCode {
  COOKIE_NOT_FOUND = 'COOKIE_NOT_FOUND',
  ERROR_SAVING_LIST_LAST_SEEN_PROPERTIES = 'ERROR_SAVING_LIST_LAST_SEEN_PROPERTIES',
  ERROR_SAVING_PROPERTY_LIKE = 'ERROR_SAVING_PROPERTY_LIKE',
  ERROR_DELETING_PROPERTY_LIKE = 'ERROR_DELETING_PROPERTY_LIKE',
  ERROR_GETTING_PROPERTY_LIKE = 'ERROR_GETTING_PROPERTY_LIKE',
  ERROR_GETTING_PROPERTY_LIKES = 'ERROR_GETTING_PROPERTY_LIKES',
  ERROR_GETTING_THEMES = 'ERROR_GETTING_THEMES',
  FORBIDDEN_COOKIE_OPERATION = 'FORBIDDEN_COOKIE_OPERATION',
  FORBIDDEN_REPOSITORY_METHOD = 'FORBIDDEN_REPOSITORY_METHOD',
  INVOICE_REQUEST_RESPONSE_NOT_FOUND = 'INVOICE_REQUEST_RESPONSE_NOT_FOUND',
  FIND_BY_IDS_PROPERTIES_NOT_FOUND = 'FIND_BY_IDS_PROPERTIES_NOT_FOUND',
  FIND_BY_BANNER_ID_PROPERTIES_NOT_FOUND = 'FIND_BY_BANNER_ID_PROPERTIES_NOT_FOUND',
  LIST_TOP_DESTINATIONS_NOT_FOUND = 'LIST_TOP_DESTINATIONS_NOT_FOUND',
  LIST_PROMOTIONS_NOT_FOUND = 'LIST_PROMOTIONS_NOT_FOUND',
  BANNERS_NOT_FOUND = 'BANNERS_NOT_FOUND',
  RELATED_PROPERTIES_NOT_FOUND = 'RELATED_PROPERTIES_NOT_FOUND',
  MISSING_BODY_SCHEMA = 'MISSING_BODY_SCHEMA',
  MISSING_FRAMEWORK_REQUEST = 'MISSING_FRAMEWORK_REQUEST',
  MISSING_HEADER = 'MISSING_HEADER',
  MISSING_HEADERS = 'MISSING_HEADERS',
  MISSING_LANGUAGE = 'MISSING_LANGUAGE',
  MISSING_LIST_LAST_SEEN_PROPERTIES = 'MISSING_LIST_LAST_SEEN_PROPERTIES',
  MISSING_MARKET = 'MISSING_MARKET',
  MISSING_QUERY_PARAM = 'MISSING_QUERY_PARAM',
  MISSING_QUERY_SCHEMA = 'MISSING_QUERY_SCHEMA',
  MISSING_RESPONSE_SCHEMA = 'MISSING_RESPONSE_SCHEMA',
  MISSING_AUTH_TOKEN = 'MISSING_AUTH_TOKEN',
  NODE_NAVIGATOR_NOT_SUPPORTED = 'NODE_NAVIGATOR_NOT_SUPPORTED',
  SPECIAL_REQUEST_RESPONSE_STATUS_NOT_FOUND = 'SPECIAL_REQUEST_RESPONSE_STATUS_NOT_FOUND',
  TOP_DESTINATION_AT_LEAST_ONE_IMAGE = 'TOP_DESTINATION_AT_LEAST_ONE_IMAGE',
  TOP_DESTINATION_IMAGE_NOT_FOUND = 'TOP_DESTINATION_IMAGE_NOT_FOUND',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  WINDOW_HEADER_NOT_SUPPORTED = 'WINDOW_HEADER_NOT_SUPPORTED',
  MISSING_PARTIAL_SEARCH_INFO = 'MISSING_PARTIAL_SEARCH_INFO',
  MISSING_SEARCH_INFO = 'MISSING_SEARCH_INFO',
  GUEST_ROOMING_LIST_CREATION_FAILED = 'GUEST_ROOMING_LIST_CREATION_FAILED',
  INVALID_BANNER_SUBTYPE = 'INVALID_BANNER_SUBTYPE',
  LOCATION_NOT_FOUND = 'LOCATION_NOT_FOUND',
}
